<template>
  <div class="container" :style="{ color: color, background: background }">
    <wrap-container class="w100">
      <footer>
        <p class="titulo p12 book" v-safe-html="text"></p>
      </footer>
    </wrap-container>
  </div>
</template>

<script>
import WrapContainer from "@/components/core/Container";

export default {
  name: "AppFooter",
  components: { WrapContainer },
  props: {
    text: String,
    color: {
      type: String,
      default: "#e4e4e4"
    },
    background: {
      type: String,
      default: "#002149"
    }
  }
};
</script>

<style scoped>
.container {
  background: #043263;
  color: #e4e4e4;
  font-size: 12px;
  line-height: 1.5em;
  padding: 30px;
  margin-left: -17px;
  margin-right: -17px;
  text-align: justify;
  margin-bottom: 0px;
}
</style>
